import React from 'react';
import { Button, FormInput, Message } from '@getro/rombo';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { Link } from 'react-router-dom';
import { Box, Flex, Text } from 'rebass/styled-components';

import { useSignInForm } from './useSignInForm';

export const SignInForm = ({ onSuccess, onError, ...rest }) => {
  const { initialValues, formSchema, onSubmit, isLoading } = useSignInForm({ onSuccess });

  return (
    <Box {...rest}>
      <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit}>
        {({ status }) => (
          <Form>
            <Field component={FormInput} data-cy="login-email" type="email" name="email" label="Email" size="large" />
            <Field
              component={FormInput}
              data-cy="login-password"
              type="password"
              name="password"
              label="Password"
              size="large"
              containerProps={{
                mt: '16px',
                sx: {
                  label: {
                    span: {
                      width: '100%',
                    },
                  },
                },
              }}
            />
            <Button mt="16px" width="100%" justifyContent="center" type="submit" loading={isLoading} size="large">
              Log in
            </Button>

            {!!status?.error && <Message mt="16px" type="error" content={status.error} />}

            <Flex mt="16px" justifyContent="center">
              <Text
                as={Link}
                to="/recover-password"
                fontSize="14px"
                fontWeight="body"
                color="text.subtle"
                sx={{ textDecoration: 'underline' }}
              >
                Forgot password or don’t have one?
              </Text>
            </Flex>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

SignInForm.propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

SignInForm.defaultProps = {
  onSuccess: null,
  onError: null,
};
